import { render, staticRenderFns } from "./InputSmallAction.vue?vue&type=template&id=b5dd0614&"
import script from "./InputSmallAction.vue?vue&type=script&lang=js&"
export * from "./InputSmallAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports